var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12081_92410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 6.85829C7.33334 6.97896 7.28889 7.09962 7.19366 7.19488C7.00953 7.37905 6.70478 7.37905 6.52066 7.19488L1.31442 1.98732C1.1303 1.80315 1.1303 1.49832 1.31442 1.31415C1.49855 1.12998 1.8033 1.12998 1.98742 1.31415L7.19366 6.52171C7.28889 6.61697 7.33334 6.73763 7.33334 6.85829Z",
    fill: "#8E98CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66658 1.14285C4.66658 1.40323 4.45071 1.61915 4.1904 1.61915L1.61903 1.61915L1.61903 4.19118C1.61903 4.45156 1.40316 4.66748 1.14285 4.66748C0.88254 4.66748 0.666672 4.45156 0.666672 4.19118L0.666672 1.14285C0.666672 0.882473 0.88254 0.66655 1.14285 0.66655L4.1904 0.66655C4.45071 0.66655 4.66658 0.882473 4.66658 1.14285Z",
    fill: "#8E98CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85861 8.66624C6.97928 8.66624 7.09994 8.71068 7.1952 8.80592C7.37937 8.99004 7.37937 9.29479 7.1952 9.47892L1.98761 14.6852C1.80344 14.8693 1.4986 14.8693 1.31443 14.6852C1.13026 14.501 1.13026 14.1963 1.31443 14.0121L6.52202 8.80592C6.61728 8.71068 6.73795 8.66624 6.85861 8.66624Z",
    fill: "#8E98CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14295 11.3331C1.40333 11.3331 1.61926 11.549 1.61926 11.8093L1.61926 14.3806L4.1913 14.3806C4.45168 14.3806 4.6676 14.5965 4.6676 14.8568C4.6676 15.1171 4.45168 15.333 4.1913 15.333L1.14295 15.333C0.882574 15.333 0.666649 15.1171 0.666649 14.8568L0.666649 11.8093C0.666649 11.549 0.882573 11.3331 1.14295 11.3331Z",
    fill: "#8E98CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66666 9.14122C8.66666 9.02056 8.71111 8.89989 8.80634 8.80463C8.99047 8.62046 9.29522 8.62046 9.47934 8.80463L14.6856 14.0122C14.8697 14.1964 14.8697 14.5012 14.6856 14.6854C14.5015 14.8695 14.1967 14.8695 14.0126 14.6854L8.80634 9.47781C8.71111 9.38255 8.66666 9.26188 8.66666 9.14122Z",
    fill: "#8E98CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 14.8567C11.3334 14.5963 11.5493 14.3804 11.8096 14.3804L14.381 14.3804L14.381 11.8083C14.381 11.548 14.5968 11.332 14.8571 11.332C15.1175 11.332 15.3333 11.548 15.3333 11.8083L15.3333 14.8567C15.3333 15.117 15.1175 15.333 14.8571 15.333L11.8096 15.333C11.5493 15.333 11.3334 15.117 11.3334 14.8567Z",
    fill: "#8E98CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14137 7.33328C9.02071 7.33328 8.90005 7.28883 8.80479 7.1936C8.62061 7.00947 8.62061 6.70472 8.80479 6.5206L14.0124 1.31436C14.1965 1.13024 14.5014 1.13024 14.6855 1.31436C14.8697 1.49848 14.8697 1.80324 14.6855 1.98736L9.47796 7.1936C9.3827 7.28883 9.26204 7.33328 9.14137 7.33328Z",
    fill: "#8E98CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.857 4.66641C14.5966 4.66641 14.3807 4.45055 14.3807 4.19023L14.3807 1.61886L11.8087 1.61886C11.5483 1.61886 11.3324 1.403 11.3324 1.14268C11.3324 0.882372 11.5483 0.666504 11.8087 0.666504L14.857 0.666503C15.1174 0.666503 15.3333 0.882371 15.3333 1.14268L15.3333 4.19023C15.3333 4.45055 15.1174 4.66641 14.857 4.66641Z",
    fill: "#8E98CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12081_92410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/move-icon.8f989903a5b0acfef3bda2fef6233712.svg";
export { ForwardRef as ReactComponent };